import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { StoreModel, StoreFilter, StoreAdminListModel, StorePlanFilter } from '../../models/store.model';
import { AuthenticationService } from '../../authentication/authentication.service';
import { Router, ActivatedRoute } from '@angular/router'
import { NgxSmartModalService } from 'ngx-smart-modal';
import { NotificationBuilder } from '../../shared/notificationBuilder'
import { ProfileService } from '../../profile/profile.service';
import { HubspotNewTicket } from '../../shared/hubspot-ticket/hubspot-ticket.component';
import { TagService } from 'src/app/services/tag.service';
import { HelperService } from 'src/app/services/helper.service';
import { TagEditor } from 'src/app/models/tagEditor';
declare var $: any;
declare var swal: any;

@Component({
    selector: 'app-stores',
    templateUrl: './stores.component.html',
    styleUrls: ['./stores.component.css']
})

export class StoresComponent implements OnInit {
    loading = false
    ticketSeoUrl: any;

    constructor(private router: Router, private route: ActivatedRoute, private profileService: ProfileService, private tagService: TagService, private helper: HelperService, private dashboardService: DashboardService, private authenticationService: AuthenticationService, public ngxSmartModalService: NgxSmartModalService, private notificationBuilder: NotificationBuilder) { }
    //accounts: AccountModel[] = null
    stores: StoreAdminListModel[] = null
    backUpStores: StoreAdminListModel[] = null
    noApi: StoreAdminListModel[] = null
    noScript: StoreAdminListModel[] = null
    noActive: StoreAdminListModel[] = null
    nextInvoiceDateWrong: StoreAdminListModel[] = null
    noPayerActive: StoreAdminListModel[] = null
    churnActive: StoreAdminListModel[] = null
    totalProblems: number = 0
    colorProblems: string = "#d9534f80";
    storeEdit: StoreModel = null
    storeFilter: StoreFilter
    planFilter: StorePlanFilter

    activeStores: number
    payingStores: number
    notActiveStores: number
    trialStores: number
    trialActiveStores: number
    totalStores: number

    freeStores: number
    freePaidStores: number
    freeInactiveStores: number
    nuvemShopInstalls: number

    totalTrials2MonthAgo: number
    totalClients2MonthAgo: number
    totalTrialsLastMonth: number
    totalClientsLastMonth: number
    totalTrialsThisMonth: number
    totalClientsThisMonth: number
    conversionTestClientLastMonth: number
    conversionTestClientThisMonth: number
    conversionTestClient2MonthAgo: number
    ticket: any
    hubspotTicket: HubspotNewTicket = null;
    name: string

    listcategories: any;
    tags: any;
    filterTag: any;
    tagModeOn: boolean = false
    tagEditor: TagEditor
    paginaAtual = 1;

    ngOnInit() {
        debugger;
        if (!this.authenticationService.isAdministrator())
            this.router.navigate(['/'])

        this.storeFilter = new StoreFilter()
        this.planFilter = new StorePlanFilter()
        this.profileService.getGetCategoryList().subscribe(data => {
            this.listcategories = data;
        });

        this.route.queryParamMap.subscribe(params => {
            if (params["params"].tag != null) {
                var tag = params["params"].tag;
                this.loadFilterTagged(tag);
            }
            else {
                this.loadAll();
            }
        });
    }

    loadFilterTagged(tag) {
        this.dashboardService.getByTag(tag).subscribe(data => {
            console.log(data)
            this.tagModeOn = true;
            this.filterTag = tag;
            this.stores = data.stores;
            this.tags = data.tags;
            this.loadStore();
        })
    }

    loadAll() {
        this.dashboardService.getCachedInTheGameStores().subscribe(data => {
            console.log(data)
            this.stores = data.stores;
            this.backUpStores = data.stores;
            this.tags = data.tags.filter(x => x.platform != "API");;
            this.noApi = data.noApi.filter(x => x.platform != "API");;
            this.noScript = data.noScript.filter(x => x.platform != "API");
            this.noActive = data.noActive.filter(x => x.platform != "API");
            this.nextInvoiceDateWrong = data.nextInvoiceDateWrong.filter(x => x.platform != "API");;
            this.noPayerActive = data.noPayerActive;
            this.churnActive = data.churnActive;
            this.totalProblems = this.noApi.length + this.noScript.length + this.noActive.length + this.noPayerActive.length + this.nextInvoiceDateWrong.length;
            if (this.totalProblems > 100) {
                this.colorProblems = "#F44336";
            }
            else if (this.totalProblems > 50) {
                this.colorProblems = "#F4433690";
            }
            else if (this.totalProblems > 30) {
                this.colorProblems = "#FFC107";
            }
            else if (this.totalProblems > 10) {
                this.colorProblems = "#FFEB3B";
            }
            else {
                this.colorProblems = "#8BC34A";
            }
            this.loadStore();
        })
    }

    reallyLoadAll(){
        this.loading = true;
        this.dashboardService.getAllStoresInHistory().subscribe(data => {
            console.log(data)
            this.stores = data.stores;
            this.backUpStores = data.stores;
            this.tags = data.tags.filter(x => x.platform != "API");;
            this.noApi = data.noApi.filter(x => x.platform != "API");;
            this.noScript = data.noScript.filter(x => x.platform != "API");
            this.noActive = data.noActive.filter(x => x.platform != "API");
            this.nextInvoiceDateWrong = data.nextInvoiceDateWrong.filter(x => x.platform != "API");;
            this.noPayerActive = data.noPayerActive;
            this.churnActive = data.churnActive;
            this.totalProblems = this.noApi.length + this.noScript.length + this.noActive.length + this.noPayerActive.length + this.nextInvoiceDateWrong.length;
            if (this.totalProblems > 100) {
                this.colorProblems = "#F44336";
            }
            else if (this.totalProblems > 50) {
                this.colorProblems = "#F4433690";
            }
            else if (this.totalProblems > 30) {
                this.colorProblems = "#FFC107";
            }
            else if (this.totalProblems > 10) {
                this.colorProblems = "#FFEB3B";
            }
            else {
                this.colorProblems = "#8BC34A";
            }
            this.loadStore();
            this.loading = false;

        })
    }

    loadStore() {
        var today = new Date();
        var firstDayThisMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        var previousMonth = today;
        previousMonth.setMonth(today.getMonth() - 1);
        var firstDayLastMonth = new Date(previousMonth.getFullYear(), previousMonth.getMonth(), 1);
        var lastDayLastMonth = new Date(previousMonth.getFullYear(), previousMonth.getMonth() + 1, 0);

        var twomonthsAgo = previousMonth;
        twomonthsAgo.setMonth(previousMonth.getMonth() - 1);
        var firstDay2MonthAgo = new Date(twomonthsAgo.getFullYear(), twomonthsAgo.getMonth(), 1);
        var lastDay2MonthAgo = new Date(twomonthsAgo.getFullYear(), twomonthsAgo.getMonth() + 1, 0);

        today = new Date();
        this.totalTrials2MonthAgo = this.stores.filter(x => !x.developmentTest && new Date(x.registrationDate).getTime() > firstDay2MonthAgo.getTime() && new Date(x.registrationDate).getTime() < lastDay2MonthAgo.getTime()).length
        this.totalClients2MonthAgo = this.stores.filter(x => x.activePayingUser && !x.developmentTest && new Date(x.registrationDate).getTime() > firstDay2MonthAgo.getTime() && new Date(x.registrationDate).getTime() < lastDay2MonthAgo.getTime()).length
        this.totalTrialsLastMonth = this.stores.filter(x => !x.developmentTest && new Date(x.registrationDate).getTime() > firstDayLastMonth.getTime() && new Date(x.registrationDate).getTime() < lastDayLastMonth.getTime()).length
        this.totalClientsLastMonth = this.stores.filter(x => x.activePayingUser && !x.developmentTest && new Date(x.registrationDate).getTime() > firstDayLastMonth.getTime() && new Date(x.registrationDate).getTime() < lastDayLastMonth.getTime()).length
        this.totalTrialsThisMonth = this.stores.filter(x => !x.developmentTest && new Date(x.registrationDate).getTime() > firstDayThisMonth.getTime() && new Date(x.registrationDate).getTime() < today.getTime()).length
        this.totalClientsThisMonth = this.stores.filter(x => x.activePayingUser && !x.developmentTest && new Date(x.registrationDate).getTime() > firstDayThisMonth.getTime() && new Date(x.registrationDate).getTime() < today.getTime()).length

        this.conversionTestClientLastMonth = 0
        this.conversionTestClientThisMonth = 0
        this.conversionTestClient2MonthAgo = 0
        if (this.totalTrials2MonthAgo > 0)
            this.conversionTestClient2MonthAgo = (this.totalClients2MonthAgo / this.totalTrials2MonthAgo) * 100.0
        if (this.totalTrialsLastMonth > 0)
            this.conversionTestClientLastMonth = (this.totalClientsLastMonth / this.totalTrialsLastMonth) * 100.0
        if (this.totalTrialsThisMonth > 0)
            this.conversionTestClientThisMonth = (this.totalClientsThisMonth / this.totalTrialsThisMonth) * 100.0

        // this.stores.forEach(function (store) {
        //   if (store.seoUrl == 'wwwprelitee'){
        //     console.log(store)
        //   }
        // });


        this.activeStores = this.stores.filter(x => !x.developmentTest && !x.trialActive && x.active).length
        this.payingStores = this.stores.filter(x => x.activePayingUser).length

        this.trialStores = this.stores.filter(x => !x.developmentTest && x.trialActive).length
        this.trialActiveStores = this.stores.filter(x => !x.developmentTest && x.trialActive && x.active).length
        this.totalStores = this.stores.filter(x => !x.developmentTest).length
        this.notActiveStores = this.stores.filter(x => !x.developmentTest && !x.trialActive && !x.active).length

        this.activeStores = this.stores.filter(x => !x.developmentTest && !x.trialActive && x.active).length
        this.payingStores = this.stores.filter(x => x.activePayingUser).length
        this.trialStores = this.stores.filter(x => !x.developmentTest && x.trialActive).length
        this.trialActiveStores = this.stores.filter(x => !x.developmentTest && x.trialActive && x.active).length
        this.totalStores = this.stores.filter(x => !x.developmentTest).length
        this.notActiveStores = this.stores.filter(x => !x.developmentTest && !x.trialActive && !x.active).length

        debugger
        this.freeStores = this.stores.filter(x => x.planName == 'free').length
        this.freePaidStores = this.stores.filter(x => x.activePayingUser && x.planName == 'free').length
        //this.freeInactiveStores = this.stores.filter(x => !x.activePayingUser && x.active && x.planName == 'free').length
        //data do lançamento Freemium NuvemShop Date.parse("03/21/2022")
        this.nuvemShopInstalls = this.stores.filter(x => Date.parse(x.registrationDate) > Date.parse("03/21/2022") && x.platform == "NuvemShop").length

        var today = new Date()
        this.stores.forEach(function (store) {
            store.filterShow = true

            if (store.productLabel != null) {
            }

            //trialEnd
            if (store.trialActive) {
                var eventStartTime = new Date();
                var eventEndTime = new Date(store.trialEndDate);
                var diff = eventEndTime.valueOf() - eventStartTime.valueOf();
                store.daysTrialLeft = Math.ceil(diff / (1000 * 3600 * 24));
            }

            if (store.suggestedPlan != null && store.planName.indexOf(store.suggestedPlan) < 0) {
                store.upSell = 'upSell ' + store.planName + ' -> ' + store.suggestedPlan
            }

            if (store.domain != null && store.domain.indexOf("http") < 0) {
                store.domain = "http://" + store.domain
            }

            var nextInvoiceDate = new Date(store.nextInvoiceDate)
            if (nextInvoiceDate.getMonth() == today.getMonth() && nextInvoiceDate.getFullYear() == today.getFullYear()) {
                if (store.planName != null && (store.planName.indexOf('semestral') > 0 || store.planName.indexOf('anual') > 0))
                    store.renewalThisMonth = true;
            }
            else {
                store.renewalThisMonth = false;
            }
        });

        this.loadTickets()
    }

    loadTickets() {
        var obj = this;
        setTimeout(() => {

            obj.ticket = { support: '-', comercial: '-', ti: '-', ngoContents: '-', supportColor: "", problemStoreIcon: "", problemStoreColor: "" };
            obj.dashboardService.countHubspotTicket(0).subscribe(data => {
                obj.ticket.support = data;
                if (data > 15) {
                    obj.ticket.supportColor = "#F44336";
                }
                else if (data > 10) {
                    obj.ticket.supportColor = "#F4433690";
                }
                else if (data > 5) {
                    obj.ticket.supportColor = "#FFC107";
                }
                else {
                    obj.ticket.supportColor = "#8BC34A";
                }
            })

            obj.dashboardService.countHubspotTicket(2450901).subscribe(data => {
                obj.ticket.comercial = data;
                if (data > 15) {
                    obj.ticket.comercialColor = "#F44336";
                }
                else if (data > 10) {
                    obj.ticket.comercialColor = "#F4433690";
                }
                else if (data > 5) {
                    obj.ticket.comercialColor = "#FFC107";
                }
                else {
                    obj.ticket.comercialColor = "#8BC34A";
                }
            })
            obj.dashboardService.countHubspotTicket(2300044).subscribe(data => {
                obj.ticket.ti = data;
                if (data > 15) {
                    obj.ticket.tiColor = "#F44336";
                }
                else if (data > 10) {
                    obj.ticket.tiColor = "#F4433690";
                }
                else if (data > 5) {
                    obj.ticket.tiColor = "#FFC107";
                }
                else {
                    obj.ticket.tiColor = "#8BC34A";
                }
            })
            obj.dashboardService.countContentNgosPendingApproval().subscribe(data => {
                obj.ticket.ngoContents = data;
                if (data > 30) {
                    obj.ticket.ngoContentsColor = "#F44336";
                }
                else if (data > 20) {
                    obj.ticket.ngoContentsColor = "#F4433690";
                }
                else if (this.totalProblems > 10) {
                    obj.ticket.ngoContentsColor = "#FFC107";
                }
                else if (this.totalProblems > 5) {
                    obj.ticket.ngoContentsColor = "#FFEB3B";
                }
                else {
                    obj.ticket.ngoContentsColor = "#8BC34A";
                }
            })

            obj.dashboardService.countProblemStores().subscribe(data => {
                obj.ticket.problemStores = data;
                if (data > 100) {
                    obj.ticket.problemStoreColor = "#F44336";
                    obj.ticket.problemStoreIcon = "😱";
                }
                else if (data > 50) {
                    obj.ticket.problemStoreColor = "#F4433690";
                    obj.ticket.problemStoreIcon = "😣";
                }
                else if (this.totalProblems > 30) {
                    obj.ticket.problemStoreColor = "#FFC107";
                    obj.ticket.problemStoreIcon = "🙁";
                }
                else if (this.totalProblems > 20) {
                    obj.ticket.problemStoreColor = "#FFEB3B";
                    obj.ticket.problemStoreIcon = "😬";
                }
                else {
                    obj.ticket.problemStoreColor = "#8BC34A";
                    obj.ticket.problemStoreIcon = "😍";
                }
            })

        }, 100);
    }

    editStore(store: StoreAdminListModel) {
        this.authenticationService.Impersonate(store.email, null)
    }

    filterByName() {
        var keyname = this.storeFilter.byname;
        this.stores = [... this.backUpStores];
        let tempStore = new Array();
        this.stores.forEach(function (store) {
            if (store.name != null) {
                store.filterShow = (store.name.toLowerCase().indexOf(keyname.toLowerCase()) >= 0)
            }
            else {
                store.filterShow = false;
            }
            if(store.filterShow)
                tempStore.push(store);
        });
        this.stores = tempStore;
    }

    filterStores(type) {
        this.stores = [... this.backUpStores];
        let tempStore = new Array();
        this.stores.forEach(function (store) {
            if (type == 'active') {
                store.filterShow = store.active && !store.trialActive
            } else if (type == 'payment') {
                store.filterShow = store.activePayingUser
            } else if (type == 'inactive') {
                store.filterShow = !store.active
            } else if (type == 'trial') {
                store.filterShow = store.trialActive
            } else if (type == 'churn') {
                store.filterShow = store.churn
            } else if (type == 'freePaid') {
                store.filterShow = store.activePayingUser && store.planName == 'free'
            }else if (type == 'upsell') {
                store.filterShow = store.upSell != null
            } else if (type == 'all') {
                store.filterShow = true
            } else if (type == 'renewal') {
                store.filterShow = store.renewalThisMonth;
                if (store.renewalThisMonth) {
                    console.log(store.seoUrl);
                }
            }

            if(store.filterShow)
                tempStore.push(store); 
        });
        this.stores = [...tempStore];
    }

    filterPerProduct(type) {
        this.stores = [... this.backUpStores];
        let tempStore = new Array();
        this.stores.forEach(function (store) {
            store.filterShow = false

            if (store.productLabel != null) {
                if (type == 'all') {
                    store.filterShow = true
                }
                if (type == store.productLabel) {
                    store.filterShow = true
                }
            }
            if(store.filterShow)
                tempStore.push(store); 
        });
        this.stores = [...tempStore];
    }

    filterPlanStores(type) {
        this.stores = [... this.backUpStores];
        let tempStore = new Array();
        this.stores.forEach(function (store) {
            store.filterShow = false

            if (store.planName != null) {
                if (type == 'all') {
                    store.filterShow = true
                }
                else{
                    store.filterShow = store.planName.indexOf(type) >= 0;
                }
            }
            else {
                store.filterShow = type == 'no-plan';
            }

            if(store.filterShow)
                tempStore.push(store); 
        });
        this.stores = [...tempStore];

    }

    filterPlataform(type) {
        this.stores = [... this.backUpStores];
        let tempStore = new Array();
        this.stores.forEach(function (store) {
            store.filterShow = false
            if (store.platform != null) {
                if (type == "all") {
                    store.filterShow = true;
                }else{
                    store.filterShow = store.platform == type;
                }
            } else {
                if (type == "independente") {
                    store.filterShow = true;
                }
            }
            if(store.filterShow)
            tempStore.push(store); 
        });
        this.stores = [...tempStore];
    }

    sendEmailStartTrial(store: StoreModel) {
        this.dashboardService.sendEmailStartTrial(store.seoUrl).subscribe(data => {
            if (data) {
                this.notificationBuilder.showNotification('success', 1000, 'Status da ' + store.name + ' email enviado!')
            } else {
                this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a alteração dos seus dados')
            }
        })
    }

    updateStatusStore(store) {

        this.dashboardService.updateStatusStore(store).subscribe(data => {
            if (data != false) {
                this.notificationBuilder.showNotification('success', 1000, 'Status da ' + store.name + ' alterado!')
            } else {
                this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a alteração dos seus dados')
            }
        })
    }

    updateCategory(store) {

        this.dashboardService.updateCategory(store).subscribe(data => {
            if (data != false) {
                this.notificationBuilder.showNotification('success', 1000, 'Status da ' + store.name + ' alterado!')
            } else {
                this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a alteração dos seus dados')
            }
        })
    }

    updateMrr(store) {

        this.dashboardService.adminUpdateMrr(store.seoUrl).subscribe(data => {
            if (data.success) {
                this.storeEdit.mrr = data.mrr;
                this.notificationBuilder.showNotification('success', 1000, 'MRR Atualizado!')
            } else {
                this.notificationBuilder.showNotification('danger', 1000, data.error);
            }
        })
    }

    updateLastPaidDate(store) {

        this.dashboardService.adminUpdateLastPaidDate(store).subscribe(data => {
            if (data != false) {
                this.notificationBuilder.showNotification('success', 1000, 'Atualizado. Feche e abra para ver atualizado.')
            } else {
                this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro.')
            }
        })
    }

    updateCountLastMonthSales(seoUrl) {

        this.dashboardService.updateCountLastMonthSales(seoUrl).subscribe(data => {
            if (data.success) {
                this.notificationBuilder.showNotification('success', 1000, data.msg)
            } else {
                this.notificationBuilder.showNotification('danger', 1000, data.error)
            }
        })
    }

    showDetails(store: StoreAdminListModel) {
        //$('body').addClass('sidebar-mini');
        this.dashboardService.getAdminStore(store.id).subscribe(data => {
            if (data) {
                console.log(data);
                this.storeEdit = data;
                this.storeEdit.category = this.storeEdit.category != null ? data.category : "";
                if (data.lead != null) {
                    this.storeEdit.couponCode = data.lead.couponCode;
                    this.storeEdit.referralCode = data.lead.referralCode;
                }
                this.ngxSmartModalService.getModal('storeModal').open()
            } else {
                this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a busca pela loja')
            }
        })

    }

    lookforScript(store: StoreAdminListModel) {
        this.notificationBuilder.showNotification('success', 1000, 'Procurando pelo Script Polen no domínio: ' + store.domain)
        this.profileService.lookforScript(store.seoUrl).subscribe(data => {
            this.loading = false
            if (data.success) {
                this.profileService.clearStoreCache(store.seoUrl).subscribe()
                if (data.hasScript) {
                    this.notificationBuilder.showNotification('success', 1000, 'Script encontrado na sua loja!')
                }
                else {
                    this.notificationBuilder.showNotification('danger', 1000, 'O script não foi encontrado. Caso já tenha inserido, por favor, fale com nosso suporte para ativarmos manualmente.')
                }

            } else {
                this.notificationBuilder.showNotification('danger', 1000, data.error)
            }
        })
    }

    showTagContainer() {
        this.tagEditor = new TagEditor()
        this.ngxSmartModalService.getModal('tagModal').open()
    }

    addTag() {
        try {
            debugger
            var list = [];
            if (this.tagEditor.storeUrls != null) {
                list = this.tagEditor.storeUrls.trim().split(',');
            }

            if (list.length > 0) {
                var code = this.helper.replaceSpaceAndAccents(this.tagEditor.tagCode.trim())
                this.tagService.addCombo(code, this.tagEditor.tagName.trim(), list).subscribe(data => {
                    if (data.success) {
                        console.log(data);
                        this.notificationBuilder.showNotification('success', 1000, 'Tag adicionada nas lojas ' + list);
                        this.ngxSmartModalService.getModal('tagModal').close()
                    } else {
                        this.notificationBuilder.showNotification('danger', 1000, 'Tag não foi adicionada. Fale com a TI');
                    }
                })
            }
            else {
                this.notificationBuilder.showNotification('danger', 1000, 'Nenhuma loja encontrada');
            }
        } catch (error) {
            this.notificationBuilder.showNotification('danger', 1000, 'Erro: ' + error);
        }

    }

    showTagRemover() {
        this.tagEditor = new TagEditor()
        this.ngxSmartModalService.getModal('removeTag').open()
    }

    removeComboTag(){
        try {
            debugger
            var list = [];
            if (this.tagEditor.storeUrls != null) {
                list = this.tagEditor.storeUrls.trim().split(',');
            }

            if (list.length > 0) {
                var code = this.helper.replaceSpaceAndAccents(this.tagEditor.tagCode.trim())
                this.tagService.removeCombo(code, this.tagEditor.tagName.trim(), list).subscribe(data => {
                    if (data.success) {
                        console.log(data);
                        this.notificationBuilder.showNotification('success', 1000, 'Tag adicionada nas lojas ' + list);
                        this.ngxSmartModalService.getModal('tagModal').close()
                    } else {
                        this.notificationBuilder.showNotification('danger', 1000, 'Tag não foi adicionada. Fale com a TI');
                    }
                })
            }
            else {
                this.notificationBuilder.showNotification('danger', 1000, 'Nenhuma loja encontrada');
            }
        } 
        catch (error) {
            this.notificationBuilder.showNotification('danger', 1000, 'Erro: ' + error);
        }
    }

    removeTag(tag:string, seoUrl:string){
        let obj = this;
        swal({
            title: 'Tem certeza que deseja deletar?',
            text: "Ao deletar a tag '" + tag + "' da loja ela não podera ser recuperado",
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Voltar',
            reverseButtons: true
          }).then((result) => {
            debugger
            if (result) {
              this.tagService.deleteLink(tag,seoUrl).subscribe(data => {
                if (data.success) {
                  obj.notificationBuilder.showNotification('success', 1000, "Deletado com sucesso")
                  window.location.reload();
                }
                else {
                  obj.notificationBuilder.showNotification('danger', 1000, data.error)
                }
              });
            }
          })
    }

    newTicket(seoUrl) {
        this.ticketSeoUrl = seoUrl
    }

    getAnswer(step: string, form: any) {
        if (step == 'ticketResponse') {
            this.ticketSeoUrl = null
            console.log(form.ticket);
        }

        if (step == 'planEditor') {
            this.ticketSeoUrl = null
            console.log(form.plan);
        }
    }

}
